var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 2.8999C5.99159 2.8999 2.40039 6.4911 2.40039 10.8999C2.40039 15.3087 5.99159 18.8999 10.4004 18.8999C12.3176 18.8999 14.0783 18.2191 15.4582 17.089L20.2348 21.8655C20.3085 21.9423 20.3968 22.0036 20.4945 22.0458C20.5922 22.0881 20.6973 22.1104 20.8038 22.1115C20.9102 22.1125 21.0158 22.0924 21.1143 22.0521C21.2129 22.0119 21.3024 21.9524 21.3776 21.8772C21.4529 21.8019 21.5124 21.7124 21.5526 21.6138C21.5929 21.5153 21.613 21.4097 21.6119 21.3033C21.6109 21.1968 21.5886 21.0917 21.5463 20.994C21.5041 20.8963 21.4428 20.808 21.366 20.7343L16.5895 15.9577C17.7196 14.5778 18.4004 12.8171 18.4004 10.8999C18.4004 6.4911 14.8092 2.8999 10.4004 2.8999ZM10.4004 4.4999C13.9445 4.4999 16.8004 7.3558 16.8004 10.8999C16.8004 14.444 13.9445 17.2999 10.4004 17.2999C6.85629 17.2999 4.00039 14.444 4.00039 10.8999C4.00039 7.3558 6.85629 4.4999 10.4004 4.4999Z",
    fill: "#222529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBig);
export default __webpack_public_path__ + "static/media/SearchBig.34440fde5e084d57a765705712f99d32.svg";
export { ForwardRef as ReactComponent };